import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=226f3caa&scoped=true"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"
import style0 from "./complain.vue?vue&type=style&index=0&id=226f3caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f3caa",
  null
  
)

export default component.exports